<template>
  <div class="form-content">
    <!-- <circle-spin v-if="is_loading"></circle-spin> -->
    <div class="table-ship">
      <data-table
        :columns="columns"
        :sortKey="sortKey"
        :sortOrders="sortOrders"
        @sort="sortBy"
        v-if="is_loading == false"
      >
        <tbody class="kt-datatable__body">
          <span v-for="data in pedido" :key="data.id">
            <router-link
              :to="{
                name: 'show-purchase-order',
                params: { id: data.id },
              }"
            >
              <tr class="kt-datatable__row">
                <td class="td-table">
                  <span class="span-title">{{ data.id }}</span>
                </td>
                <td class="td-table">
                  <span class="span-title">{{ data.attributes.product_info }}</span>
                </td>
                <td class="td-table">
                  <span class="span-title">F. compra: <br> {{ data.attributes.order_create_date }} <br> F. entrega: <br>{{ data.attributes.promised_delivery_date }}</span>
                </td>
                <td class="td-table">
                  <span class="span-title">Pago: <br> Pendiente <br> Tracking: <br> Pendientes</span>
                </td>
                <td class="td-table">
                  <span class="span-title"
                    >{{ data.attributes.currency }}
                    {{
                      (data.attributes.total_cost * data.attributes.exchange).toFixed(2)
                    }}</span
                  >
                </td>
              </tr>
            </router-link>
          </span>
        </tbody>
      </data-table>
    </div>

    <pagination
      :pagination="pagination"
      @changePagination="getPedidos"
      v-if="is_loading == false"
    ></pagination>
  </div>
</template>
<script>
import DataTable from "@/components/views/DataTable.vue";
import Pagination from "@/components/views/Pagination.vue";
import axios from "axios";
export default {
  props: ["idUser"],
  components: { DataTable, Pagination },
  created() {
    this.getPedidos();
  },
  data() {
    let sortOrders = {};
    let columns = [
      { label: "N° Orden", name: "id", visible: true },
      { label: "Descripción", name: "product_info", visible: true },
      { label: "Fecha ", name: "fechaCreada", visible: true },
      { label: "Estado", name: "state", visible: true },
      { label: "Monto", name: "total_cost", visible: true },
    ];
    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });
    return {
      pedido: null,
      columns,
      sortKey: "updated_at",
      sortOrders: sortOrders,
      filterKey: "",
      tableData: {
        orderBy: "created_at",
        length: 4,
        page: 1,
      },
      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: "",
      },
      is_loading: true,
    };
  },
  methods: {
    getPedidos(page) {
      this.is_loading = true;
      //   this.tableData.draw++;
      this.tableData.page = page;
      let url =
        process.env.API_URL +
        "/api/purchaseOrder/" +
        this.idUser +
        "/list-orders-by-client";

      // eslint-disable-next-line no-unreachable
      axios
        .get(url, { params: this.tableData })
        .then((response) => {
          this.pedido = response.data.data;
          this.is_loading = false;
          this.configPagination(response.data);
        })
        .catch(() => {
          alert("No se obtuvieron resultados");
          this.is_loading = false;
          return;
        });
    },
    cleanInput() {
      this.tableData.filterValue = "";
    },
    configPagination(data) {
      this.pagination.lastPage = data.meta.last_page;
      this.pagination.currentPage = data.meta.current_page;
      this.pagination.total = data.meta.total;
      this.pagination.lastPageUrl = data.links.last;
      this.pagination.nextPageUrl = data.links.next;
      this.pagination.prevPageUrl = data.links.prev;
      this.pagination.from = data.meta.from;
      this.pagination.to = data.meta.to;
      this.pagination.perPage = this.tableData.length;
    },
    sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableData.orderBy = this.sortOrders;
      /* this.tableData.orderBy = this.getIndex(this.columns, 'name', key) */

      this.tableData.dir = this.sortOrders[key] === 1 ? "asc" : "desc";

      this.getPedidos();
    },
    getIndex(array, key, value) {
      return array.findIndex((i) => i[key] === value);
    },
  },
  computed: {
    filterColumns() {
      let activeFilterColumns = ["document_number", "email", "fullname", "cellphone"];
      return this.columns.filter((i) => activeFilterColumns.indexOf(i.name) > -1);
    },
  },
};
</script>

<style lang="css" scoped></style>



// WEBPACK FOOTER //
// PedidoComponent.vue?e1977c6c